(function () {
  // Tracks clicks on Shopify's dynamic checkout button (Buy it now / Shop Pay / PayPal etc).
  // That button is a separate Shopify-owned element (<shopify-accelerated-checkout>) that
  // posts straight to /checkouts/... and bypasses product-form.js's /cart/add.js submit flow
  // entirely, so standard add-to-cart tracking never fires for these sessions. This pushes a
  // dataLayer event before navigation so GA4/GTM can see purchase intent on this path too.
  // Verified selector against the live PDP DOM (2026-08-19): '.product-form__buttons
  // [data-shopify="payment-button"]' and '.shopify-payment-button' each matched exactly the
  // single accelerated-checkout wrapper on the page.

  function findVariantId(button) {
    var form = button.closest('product-form');
    var input = form ? form.querySelector('.product-variant-id') : null;
    if (!input) {
      var fallbackForm = button.closest('form');
      input = fallbackForm ? fallbackForm.querySelector('.product-variant-id') : null;
    }
    return input ? input.value : null;
  }

  function attach(button) {
    if (button.dataset.buyNowTrackingBound) return;
    button.dataset.buyNowTrackingBound = 'true';
    // capture: true so this fires even if the accelerated-checkout element's own click
    // handling stops propagation before it reaches a bubble-phase listener.
    button.addEventListener('click', function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'buy_now_click',
        variant_id: findVariantId(button),
        page_url: window.location.href
      });
    }, { capture: true });
  }

  function scan() {
    document
      .querySelectorAll('.product-form__buttons [data-shopify="payment-button"], .shopify-payment-button')
      .forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Section Rendering API can re-render product-form__buttons on variant change, which
  // replaces the button node — re-scan on DOM mutations so the listener stays attached.
  var observer = new MutationObserver(scan);
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
